import type { ExtractStrict } from 'types';

import type { StatusType } from './statusType';

interface StoreStock {
	inStock: boolean;
	productInStockAtStores: number;
	storeSelected: boolean;
}

export function getProductCardStoreStockStatus({
	inStock,
	productInStockAtStores,
	storeSelected,
}: StoreStock): ProductCardStoreStockStatusType {
	switch (true) {
		case storeSelected && inStock:
			return 'Store-InStock';
		case storeSelected && !inStock:
			return 'Store-OutOfStock';
		case productInStockAtStores > 0:
			return 'NoStore-InStock';
		case productInStockAtStores === 0:
			return 'NoStore-OutOfStock';
		default:
			return 'MatchFailed';
	}
}

export type ProductCardStoreStockStatusType = ExtractStrict<
	StatusType,
	| 'MatchFailed'
	| 'NoStore-InStock'
	| 'NoStore-OutOfStock'
	| 'Store-InStock'
	| 'Store-OutOfStock'
>;
